import { useIsBelowBreakpoint } from '@brightlocal/ui-components/hooks/use-breakpoint';

import { FILTER_TRIGGER_SIZE } from '../consts';

/** Size of a review filter's trigger: small below the `md` breakpoint, where the filters open as drawers. */
export const useFilterTriggerSize = () => {
  const isMobile = useIsBelowBreakpoint('md');

  return isMobile ? FILTER_TRIGGER_SIZE.SM : FILTER_TRIGGER_SIZE.DEFAULT;
};
